import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../admin/FirebaseConfig"; // Adjust the path as needed

const Calculator = () => {
  const [loanType, setLoanType] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [interestRate, setInterestRate] = useState("");
  const [emi, setEmi] = useState("");

  const [mobileNumber, setMobileNumber] = useState("");
  const [trackingResult, setTrackingResult] = useState(null);

  const calculateEMI = () => {
    if (!loanType || !loanAmount || !loanTenure || !interestRate) {
      alert("Please fill in all fields");
      return;
    }
    const rate = interestRate / 12 / 100;
    const tenure = loanTenure * 12;
    const emiValue =
      (loanAmount * rate * Math.pow(1 + rate, tenure)) /
      (Math.pow(1 + rate, tenure) - 1);
    setEmi(emiValue.toFixed(2));
  };

  const handleTrackApplication = async (e) => {
    e.preventDefault();
    setTrackingResult(null);

    if (!mobileNumber.trim()) {
      alert("Please enter your registered mobile number");
      return;
    }

    try {
      const applicationsRef = collection(firestore, "loanApplications");
      const q = query(applicationsRef, where("phone", "==", mobileNumber));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();
        setTrackingResult({
          name: data.fullName,
          status: data.status,
        });
      } else {
        alert("No application found for this mobile number.");
      }
    } catch (error) {
      console.error("Error fetching application:", error);
      alert("Error tracking application. Please try again.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row g-4">
        {/* Header Section */}
        <div className="col-12 text-center mb-4">
          <h2 style={{ 
            color: '#8B0000', 
            fontWeight: '700',
            textShadow: '0px 1px 2px rgba(0,0,0,0.1)'
          }}>
            Aditya Birla Capital Financial Tools
          </h2>
          <p className="text-muted">Plan your financial future with our premium calculators</p>
        </div>

        {/* Loan Calculator Column */}
        <div className="col-12 col-lg-8">
          <div
            className="shadow-lg rounded-4 p-4 h-100"
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
              border: '1px solid rgba(139, 0, 0, 0.1)',
              minHeight: "400px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div className="d-flex align-items-center mb-3">
                <div style={{
                  width: '8px',
                  height: '40px',
                  backgroundColor: '#8B0000',
                  borderRadius: '10px',
                  marginRight: '15px'
                }}></div>
                <h4 className="mb-0" style={{ color: '#343a40', fontWeight: '600' }}>Loan Calculator</h4>
              </div>
              
              <p className="text-muted mb-4">
                Calculate your EMI for different loan options to make informed financial decisions
              </p>
              
              <div className="row g-3">
                <div className="col-12 col-sm-6 col-md-3">
                  <label htmlFor="loanType" className="form-label fw-semibold">Loan Type</label>
                  <select
                    className="form-select shadow-sm"
                    id="loanType"
                    value={loanType}
                    style={{ 
                      borderRadius: '8px',
                      border: '1px solid #ced4da',
                      padding: '10px'
                    }}
                    onChange={(e) => setLoanType(e.target.value)}
                  >
                    <option value="" disabled>Select Loan Type</option>
                    <option value="business">Digital Business Loan</option>
                    <option value="bond">Loan Against Bond</option>
                    <option value="educationBond">Education Loan Against Bond</option>
                    <option value="Home Loan">Home Loan</option>
                    <option value="Car Loan">Car Loan</option>
                    <option value="Personal Loan">Personal Loan</option>
                    <option value="Education Loan">Education Loan</option>
                  </select>
                </div>

                <div className="col-12 col-sm-6 col-md-3">
                  <label htmlFor="loanAmount" className="form-label fw-semibold">Loan Amount (₹)</label>
                  <input
                    type="number"
                    className="form-control shadow-sm"
                    id="loanAmount"
                    value={loanAmount}
                    style={{ 
                      borderRadius: '8px',
                      border: '1px solid #ced4da',
                      padding: '10px'
                    }}
                    onChange={(e) => setLoanAmount(e.target.value)}
                    placeholder="Enter amount"
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-3">
                  <label htmlFor="loanTenure" className="form-label fw-semibold">Tenure (Years)</label>
                  <select
                    className="form-select shadow-sm"
                    id="loanTenure"
                    value={loanTenure}
                    style={{ 
                      borderRadius: '8px',
                      border: '1px solid #ced4da',
                      padding: '10px'
                    }}
                    onChange={(e) => setLoanTenure(e.target.value)}
                  >
                    <option value="" disabled>Select Tenure</option>
                    <option value="1">1 Year</option>
                    <option value="2">2 Years</option>
                    <option value="3">3 Years</option>
                    <option value="5">5 Years</option>
                    <option value="10">10 Years</option>
                    <option value="15">15 Years</option>
                    <option value="20">20 Years</option>
                  </select>
                </div>

                <div className="col-12 col-sm-6 col-md-3">
                  <label htmlFor="interestRate" className="form-label fw-semibold">Interest Rate (%)</label>
                  <input
                    type="number"
                    className="form-control shadow-sm"
                    id="interestRate"
                    value={interestRate}
                    style={{ 
                      borderRadius: '8px',
                      border: '1px solid #ced4da',
                      padding: '10px'
                    }}
                    onChange={(e) => setInterestRate(e.target.value)}
                    placeholder="Enter rate"
                  />
                </div>
              </div>
            </div>

            <div className="mt-4">
              <div className="d-flex align-items-center flex-wrap">
                <button
                  className="btn btn-lg mb-2 shadow"
                  style={{ 
                    backgroundColor: "#8B0000", 
                    color: "white",
                    borderRadius: '8px',
                    padding: '10px 25px',
                    fontWeight: '600',
                    border: 'none',
                    transition: 'all 0.3s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#6d0000';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#8B0000';
                    e.target.style.transform = 'translateY(0)';
                  }}
                  onClick={calculateEMI}
                >
                  Calculate EMI
                </button>

                {emi && (
                  <div
                    className="p-3 ms-md-3 mt-2 mt-md-0 shadow-sm"
                    style={{
                      border: "1px solid #28a745",
                      borderRadius: "12px",
                      backgroundColor: "#f8fff9",
                      maxWidth: "100%",
                      flex: '1'
                    }}
                  >
                    <h6 className="text-muted mb-1">Estimated Monthly Payment</h6>
                    <h3 className="text-success mb-0">₹{emi}</h3>
                    <small className="text-muted">Per month for {loanTenure} years</small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Track Application Column */}
        <div className="col-12 col-lg-4">
          <div
            className="shadow-lg rounded-4 p-4 h-100"
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
              border: '1px solid rgba(139, 0, 0, 0.1)',
              minHeight: "400px",
            }}
          >
            <div className="d-flex align-items-center mb-3">
              <div style={{
                width: '8px',
                height: '40px',
                backgroundColor: '#8B0000',
                borderRadius: '10px',
                marginRight: '15px'
              }}></div>
              <h4 className="mb-0" style={{ color: '#343a40', fontWeight: '600' }}>Track Your Application</h4>
            </div>
            
            <p className="text-muted mb-4">
              Enter your registered mobile number to check your application status
            </p>
            
            <form onSubmit={handleTrackApplication}>
              <div className="mb-4">
                <label htmlFor="mobileNumber" className="form-label fw-semibold">
                  Registered Mobile Number
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="mobileNumber"
                  value={mobileNumber}
                  style={{ 
                    borderRadius: '8px',
                    border: '1px solid #ced4da',
                    padding: '12px'
                  }}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  placeholder="Enter 10-digit mobile number"
                />
              </div>
              <button
                type="submit"
                className="btn btn-lg w-100 shadow"
                style={{ 
                  backgroundColor: "#8B0000", 
                  color: "white",
                  borderRadius: '8px',
                  padding: '12px',
                  fontWeight: '600',
                  border: 'none',
                  transition: 'all 0.3s'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#6d0000';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#8B0000';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Track Application
              </button>
            </form>

            {trackingResult && (
              <div className="alert alert-info mt-4 shadow-sm" style={{ borderRadius: '12px', border: 'none' }}>
                <h6 className="fw-semibold">Application Details</h6>
                <div className="d-flex mt-3">
                  <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#8B0000', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px' }}>
                    <i className="fas fa-user text-white"></i>
                  </div>
                  <div>
                    <strong>Name:</strong> {trackingResult.name} <br />
                    <strong>Status:</strong> <span className="badge bg-success">{trackingResult.status}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Additional Information Section */}
      <div className="row mt-5">
        <div className="col-12">
          <div className="p-4 rounded-4 shadow-sm" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #8B0000' }}>
            <h5 style={{ color: '#8B0000', fontWeight: '600' }}>Why Choose Aditya Birla Capital?</h5>
            <div className="row mt-3">
              <div className="col-md-4 mb-3">
                <div className="d-flex align-items-center">
                  <div className="p-2 rounded-circle me-3" style={{ backgroundColor: 'rgba(139, 0, 0, 0.1)', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="fas fa-bolt" style={{ color: '#8B0000' }}></i>
                  </div>
                  <div>
                    <h6 className="mb-0">Quick Approval</h6>
                    <small className="text-muted">Fast processing of loans</small>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="d-flex align-items-center">
                  <div className="p-2 rounded-circle me-3" style={{ backgroundColor: 'rgba(139, 0, 0, 0.1)', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="fas fa-percent" style={{ color: '#8B0000' }}></i>
                  </div>
                  <div>
                    <h6 className="mb-0">Competitive Rates</h6>
                    <small className="text-muted">Low interest rates</small>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="d-flex align-items-center">
                  <div className="p-2 rounded-circle me-3" style={{ backgroundColor: 'rgba(139, 0, 0, 0.1)', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="fas fa-headset" style={{ color: '#8B0000' }}></i>
                  </div>
                  <div>
                    <h6 className="mb-0">24/7 Support</h6>
                    <small className="text-muted">Dedicated customer care</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;